import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  TextField,
  OutlinedInput,
  InputLabel,
  FormControl,
  FormHelperText,
  MenuItem,
  Divider,
  Typography,
} from "@material-ui/core";

import { CountryList, TimeZoneOptions } from "../utils/constants";
import useForm from "../utils/useForm";
import SetupContext from "./context";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  selectedAccess: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  addButton: {
    marginTop: theme.spacing(1.25),
    marginLeft: theme.spacing(1),
  },
  addInput: {
    marginTop: theme.spacing(1),
    minWidth: "50%",
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export const YardInfo = () => {
  const classes = useStyles();
  const { state, dispatch } = useContext(SetupContext);
  const { yardInfo } = state;
  const { handleChange } = useForm(state, dispatch, "yardInfo");

  let { errors } = state;

  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item xs={12}>
        <Typography variant="subtitle1">User information</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="firstName"
          label="First name"
          id="firstName"
          helperText={errors["firstName"] ? errors["firstName"] : ""}
          autoFocus
          error={errors["firstName"] ? true : false}
          margin="dense"
          required
          variant="outlined"
          fullWidth
          value={yardInfo.firstName}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="lastName"
          label="Last name"
          id="lastName"
          helperText={errors["lastName"] ? errors["lastName"] : ""}
          error={errors["lastName"] ? true : false}
          required
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.lastName}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="userPhone"
          label="Phone number"
          id="userPhone"
          helperText={errors["userPhone"] ? errors["userPhone"] : ""}
          error={errors["userPhone"] ? true : false}
          required
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.userPhone}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="userEmail"
          label="Email"
          id="userEmail"
          disabled
          required
          margin="dense"
          variant="outlined"
          fullWidth
          value={window.appUser?.email}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <div className={classes.divider}>
          <Divider variant="fullWidth"></Divider>
        </div>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle1">Business information</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="businessName"
          label="Business name"
          id="businessName"
          helperText={errors["businessName"] ? errors["businessName"] : ""}
          error={errors["businessName"] ? true : false}
          margin="dense"
          required
          variant="outlined"
          fullWidth
          value={yardInfo.businessName}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="phoneNumber"
          label="Phone number"
          id="phoneNumber"
          helperText={errors["phoneNumber"] ? errors["phoneNumber"] : ""}
          error={errors["phoneNumber"] ? true : false}
          required
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.phoneNumber}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="faxNumber"
          label="Fax number"
          id="faxNumber"
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.faxNumber}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="email"
          label="Email"
          id="email"
          helperText={errors["email"] ? errors["email"] : ""}
          error={errors["email"] ? true : false}
          required
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.email}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth margin="dense" variant="outlined">
          <InputLabel htmlFor="outlined-dense-website">Website</InputLabel>
          <OutlinedInput
            type="url"
            name="website"
            label="Website"
            id="url"
            error={errors["website"] ? true : false}
            value={yardInfo.website}
            onChange={handleChange}
          />
          <FormHelperText id="outlined-website-helper-text">
            {errors["website"] ? errors["website"] : ""}
          </FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}></Grid>
      <Grid item xs={12} sm={12}>
        <div className={classes.divider}>
          <Divider variant="fullWidth"></Divider>
        </div>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle1">Business address</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="street"
          label="Street"
          id="street"
          helperText={errors["street"] ? errors["street"] : ""}
          error={errors["street"] ? true : false}
          required
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.street}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="city"
          label="City"
          id="city"
          helperText={errors["city"] ? errors["city"] : ""}
          error={errors["city"] ? true : false}
          required
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.city}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="state"
          label="State/Province"
          id="state"
          margin="dense"
          variant="outlined"
          fullWidth
          required
          inputProps={{ maxLength: 2, style: { textTransform: "uppercase" } }}
          helperText={errors["state"] ? errors["state"] : ""}
          error={errors["state"] ? true : false}
          value={yardInfo.state}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="zip"
          label="Postal code"
          helperText={errors["zip"] ? errors["zip"] : ""}
          error={errors["zip"] ? true : false}
          required
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.zip}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="country"
          label="Country"
          id="country"
          select
          margin="dense"
          variant="outlined"
          fullWidth
          required
          helperText={errors["country"] ? errors["country"] : ""}
          error={errors["country"] ? true : false}
          value={yardInfo.country}
          onChange={handleChange}
        >
          {CountryList.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="timeZone"
          label="Time Zone"
          id="timeZone"
          select
          margin="dense"
          variant="outlined"
          fullWidth
          required
          helperText={errors["timeZone"] ? errors["timeZone"] : ""}
          error={errors["timeZone"] ? true : false}
          value={yardInfo.timeZone}
          onChange={handleChange}
        >
          {TimeZoneOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};
